export default __webpack_public_path__ + "static/media/MXTakatak.21ac2a79.png";